import { CommonModule } from "@angular/common";
import { Component, Inject, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { TranslateModule } from "@ngx-translate/core";
import { TilbyMagicFormComponent } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { InputItemDataMagicForm } from "src/app/shared/model/model";
import { PayPalDialogService, PaypalDialogData, PaypalDialogForm } from "./paypal-dialog.service";
import { SettingsAlvoloContentComponent } from "src/app/features";
import { MagicPortalDialogComponent } from "../../magic-portal-dialog";
import { OnDestroyService } from 'src/app/core/services/on-destroy.service';
import { PortalConfigData } from "../../services";

@Component({
    selector: 'paypal-dialog',
    templateUrl: './paypal-dialog.component.html',
    styleUrls: ['./paypal-dialog.component.scss'],
    standalone: true,
    imports: [
        TilbyMagicFormComponent,
        CommonModule,
        MatListModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
    ],
    providers:[OnDestroyService]
})
export class PayPalDialogComponent {
    protected readonly onDestroyService = inject(OnDestroyService);
    protected readonly paypalDialogService = inject(PayPalDialogService);
    
    constructor(
        public dialogRef: MatDialogRef<SettingsAlvoloContentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: InputItemDataMagicForm<PaypalDialogForm>
    ){
        this.subscriptions();
    }

    cancel() {
        this.dialogRef.close({ cancel: true });
    }

    private subscriptions(){
        MagicPortalDialogComponent.confirm$.pipe(this.onDestroyService.takeUntilDestroy).subscribe((res: PortalConfigData<PaypalDialogData, PayPalDialogComponent>) => res.form.valid && this.paypalDialogService.confirm(res.form.value));
    }
}